<template>
  <MobileAuth ref="mobileAuth" :authType="'EMAIL'" :formTitle="'이메일'">
    <template v-slot:titleArea> </template>

    <template v-slot:msgArea>
      <div class="msg">
        <div style="margin-bottom:30px;">
          사전에 등록한 이메일 인증을 통해 번호 변경이 가능합니다.
        </div>
        <!-- <div>※ 잠깐! 기존의 번호에 이메일을 먼저 등록해 놓아야만,</div>
        <div>인증이 가능합니다. (마이페이지 > 이메일 등록)</div> -->
      </div>
    </template>

    <template v-slot:btnArea="btnAreaProps">
      <!-- [hsh - 20220107] -->
      <div class="msg_bot">
        <div>※ 이메일 등록은 기존의 번호로 로그인을 하신 후</div>
        <div>등록이 가능합니다. (마이페이지 > 이메일 등록)</div>
      </div>
      <div class="btm_btn">
        <div class="btn_wrap">
          <button
            class="btn"
            :disabled="!btnAreaProps.isAvailable"
            @click="Authenticate()"
          >
            인증하기
          </button>
        </div>
      </div>
    </template>
  </MobileAuth>
</template>
<script>
import MobileAuth from './components/MobileAuth';
import { authMapActions, authTypes } from '@common/store/modules';

export default {
  components: {
    MobileAuth,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...authMapActions([authTypes.LOGIN]),
    Authenticate() {
      this.$refs.mobileAuth.handleAuthConfirm((email, authNumber) => {
        this.$router.push({
          name: 'Auth.PhoneNumberChange',
          query: {
            email: email,
            authNumber: authNumber,
          },
        });
      });
    },
  },
};
</script>
